/* eslint-disable prettier/prettier */
<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-66 md-xsmall-size-80 mx-auto">
      <simple-wizard>
        <template slot="header">
          <h3 class="title">Neues Verfahren anlegen</h3>
          <h5 class="category">
            Lege hier ein Los-Verfahren an um Hecken in einer Ausschreibung zu
            gruppieren.
          </h5>
        </template>

        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">
            Start
          </template>
          <first-step ref="step1" @on-validated="onStepValidated"></first-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">
            Was
          </template>
          <second-step
            ref="step2"
            @on-validated="onStepValidated"
          ></second-step>
        </wizard-tab>

        <!-- <wizard-tab :before-change="() => validateStep('step3')"> -->
        <wizard-tab>
          <template slot="label">
            Wo
          </template>
          <third-step ref="step3"></third-step>
        </wizard-tab>

        <wizard-tab :before-change="() => validateStep('step4')">
          <template slot="label">
            Wann
          </template>
          <fourth-step ref="step4" @on-validated="wizardComplete"></fourth-step>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>
<script>
import FirstStep from "./VerfahrenNeu/FirstStep.vue";
import SecondStep from "./VerfahrenNeu/SecondStep.vue";
import ThirdStep from "./VerfahrenNeu/ThirdStep.vue";
import FourthStep from "./VerfahrenNeu/FourthStep.vue";
import swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";

export default {
  data() {
    return {
      wizardModel: {}
    };
  },
  components: {
    FirstStep,
    SecondStep,
    ThirdStep,
    FourthStep,
    SimpleWizard,
    WizardTab
  },
  methods: {
    validateStep(ref) {
      return this.$refs[ref].validate();
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    wizardComplete() {
      swal({
        title: "Good job!",
        text: "You clicked the finish button!",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false
      });
    }
  }
};
</script>
